module.exports = __webpack_public_path__ + "static/media/breaking_stone2.1bbe32df.gif";